import React from "react";
import { NavLink } from "react-router-dom";
import { Home, QrCode, Gift, User } from "lucide-react";

/**
 * Mobile-only bottom navigation. Hidden at >= md (desktop uses TopNav).
 * Pinned to the viewport bottom (NOT inside a phone container — that
 * pattern is gone after the responsive pivot).
 */
const TABS = [
  { to: "/customer/dashboard", label: "Home", Icon: Home, testId: "nav-home" },
  { to: "/customer/qr", label: "QR", Icon: QrCode, testId: "nav-qr" },
  { to: "/customer/rewards", label: "Rewards", Icon: Gift, testId: "nav-rewards" },
  { to: "/customer/profile", label: "Profile", Icon: User, testId: "nav-profile" },
];

const TabButton = ({ to, label, Icon, testId }) => (
  <NavLink
    to={to}
    data-testid={testId}
    end={false}
    className={({ isActive }) =>
      [
        "relative flex flex-1 flex-col items-center justify-center h-full",
        "font-body font-semibold text-[10px] tracking-[0.1em] uppercase",
        "transition-colors duration-200",
        isActive
          ? "text-napoli-gold"
          : "text-napoli-cream/60 hover:text-napoli-cream/85",
      ].join(" ")
    }
  >
    {({ isActive }) => (
      <>
        {isActive ? (
          <span
            aria-hidden
            className="absolute top-2 h-0.5 w-8 bg-napoli-gold"
          />
        ) : null}
        <Icon
          size={22}
          strokeWidth={1.6}
          className="mb-1"
          style={
            isActive
              ? { filter: "drop-shadow(0 0 6px rgba(197,160,77,0.55))" }
              : undefined
          }
        />
        <span>{label}</span>
      </>
    )}
  </NavLink>
);

export const CustomerBottomNav = () => (
  <nav
    data-testid="customer-bottom-nav"
    aria-label="Customer navigation"
    className="md:hidden fixed bottom-0 left-0 right-0 h-[72px] bg-napoli-espresso flex items-stretch z-30 border-t border-napoli-gold/20"
  >
    {TABS.map((t) => (
      <TabButton key={t.to} {...t} />
    ))}
  </nav>
);

export default CustomerBottomNav;
